import FlightSummary from './FlightSummary';

export default FlightSummary;
